export interface Turnstile {
    render(
        container: HTMLElement,
        options: {
            sitekey: string;
            callback: () => void;
            "error-callback": () => void;
            "expired-callback": () => void;
            size: "normal" | "flexible" | "compact";
            theme: "light" | "dark" | "auto";
        },
    ): string | undefined;
    remove(widgetId: string): void;
}

declare global {
    interface Window {
        turnstile?: Turnstile;
    }
}

const SCRIPT_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
const LOAD_TIMEOUT = 6000;

let loading: Promise<Turnstile> | null = null;

/** Загрузить скрипт Cloudflare Turnstile один раз на страницу */
export function loadTurnstile(): Promise<Turnstile> {
    if (window.turnstile) return Promise.resolve(window.turnstile);

    loading ??= new Promise<Turnstile>((resolve, reject) => {
        const script = document.createElement("script");
        const timeout = setTimeout(() => reject(new Error("Turnstile load timeout")), LOAD_TIMEOUT);

        script.src = SCRIPT_SRC;
        script.async = true;
        script.addEventListener("load", () => {
            clearTimeout(timeout);
            if (window.turnstile) resolve(window.turnstile);
            else reject(new Error("Turnstile is not initialized"));
        });
        script.addEventListener("error", () => {
            clearTimeout(timeout);
            reject(new Error("Turnstile script failed to load"));
        });

        document.head.append(script);
    }).catch((error: unknown) => {
        // Allow another attempt next time
        loading = null;
        throw error;
    });

    return loading;
}
